import { render, staticRenderFns } from "./PerfilParcelasView.vue?vue&type=template&id=6005f73b"
import script from "./PerfilParcelasView.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilParcelasView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports